"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tooltip = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Tooltip = require("./Tooltip.styles");
var _OffsetBox = require("../../Layout/OffsetBox");
var _useOffsetBox = require("../../Layout/OffsetBox/useOffsetBox");
var _Card = require("../Card");
var _dom = require("../../utilities/dom");
var _hooks = require("../../hooks");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Tooltip = props => {
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const {
    anchor,
    children,
    isOpenOnFocus,
    isInteractive,
    position = 'bottom',
    anchorWidth = 'fit-content',
    header
  } = props;
  const {
    anchorRef,
    dropContentRef,
    handleAnchorFocus,
    handleOffsetBoxBlur,
    handleOffsetBoxLeave,
    isOpen,
    close,
    open
  } = (0, _useOffsetBox.useOffsetBox)(isOpenOnFocus);
  const [actualBoxPosition, setActualBoxPosition] = (0, _react.useState)(position);
  const styles = (0, _Tooltip.useStyles)(actualBoxPosition, props);
  const handleBoxPositionChange = pos => {
    setActualBoxPosition(pos);
  };
  const handleAnchorBlur = () => {
    if (isInteractive && dropContentRef.current) {
      const tabAble = (0, _dom.getKeyboardFocusableElements)(dropContentRef.current);
      if (tabAble.length > 0) {
        tabAble[0].focus();
        handleOffsetBoxBlur();
        return;
      }
    }
    close();
  };
  const handleAnchorClick = event => {
    event.preventDefault();
    event.stopPropagation();
    if (isMobileView) {
      open();
    }
  };
  (0, _react.useEffect)(() => {
    if (position) {
      setActualBoxPosition(position);
    }
  }, [position]);
  const anchorTabIndex = isOpenOnFocus && anchorRef?.current && (0, _dom.getKeyboardFocusableElements)(anchorRef?.current).length === 0 ? 0 : -1;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: styles['cc-Tooltip'],
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_OffsetBox.OffsetBox, {
      position: position,
      offset: 0,
      isOpen: isOpen,
      isCenteredToAnchor: true,
      onBoxPositionChange: handleBoxPositionChange,
      anchorWidth: anchorWidth,
      anchor: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        ref: anchorRef,
        onClick: handleAnchorClick,
        onMouseEnter: isMobileView ? undefined : open,
        onMouseLeave: isMobileView ? undefined : isInteractive ? handleOffsetBoxLeave : close,
        tabIndex: anchorTabIndex,
        onFocus: handleAnchorFocus,
        onBlur: handleAnchorBlur,
        children: anchor
      }),
      children: children && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: styles['cc-Tooltip__content'],
        ref: dropContentRef,
        onMouseEnter: isInteractive ? open : undefined,
        onMouseLeave: isInteractive ? handleOffsetBoxLeave : undefined,
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Card.Card, {
          children: [header && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: styles['cc-Tooltip__header'],
            children: header
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Card.Card.Section, {
            size: "small",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: styles['cc-Tooltip__inner-content'],
              children: children
            })
          })]
        })
      })
    })
  });
};
exports.Tooltip = Tooltip;